/**
 * Generic API slice — request lifecycle action types.
 *
 * The api slice is intentionally generic so components don't need to wire
 * up per-endpoint constants/actions/reducers/sagas. Components dispatch a
 * single `apiRequest({ key, endpoint, ... })` and read state by `key`.
 */

export const API_REQUEST = 'API_REQUEST';
export const API_REQUEST_SUCCESS = 'API_REQUEST_SUCCESS';
export const API_REQUEST_FAILURE = 'API_REQUEST_FAILURE';
export const API_RESET = 'API_RESET';
